import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useToast } from '@/contexts/ToastContext';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

/** Toast once when connectivity changes (offline / back online). */
export function useOnlineTransition(scope: string): boolean {
  const online = useOnlineStatus();
  const { t } = useTranslation();
  const toast = useToast();
  const prevRef = useRef<boolean | null>(null);
  const toastRef = useRef(toast);
  toastRef.current = toast;

  useEffect(() => {
    if (prevRef.current === null) {
      prevRef.current = online;
      return;
    }
    if (prevRef.current === online) return;
    prevRef.current = online;
    if (!online) {
      toastRef.current.error(t('cashbook.offlineToast'), `${scope}-offline`);
    } else {
      toastRef.current.success(t('online.backOnline'), `${scope}-online`);
    }
  }, [online, scope, t]);

  return online;
}
